const initialState = {
    validationsByGroup: [],
    refDataEventProcess:[],
    refDataEventProcessOrders:[],
    gridOptions: {},
    rowData: []
};
export default initialState;